import { ApiTypes } from '../../api/api-types';
import { QuestionType } from '../../core/interfaces/general.interface';
import {
  CampaignRespDto,
  ICampaign,
  ICampaignContent,
  ICampaignInfo,
  ICampaignOptions,
  ICampaignQuestion,
} from './interfaces/campaign.interface';

type CampaignContentDto = ApiTypes.CampaignTakeawayContentResponseDto;
type CampaignInfoDto = ApiTypes.CampaignTakeawayInfoResponseDto;
type CampaignQuestionDto = ApiTypes.CampaignTakeawayQuestionResponseDto;
type CampaignOptionDto = ApiTypes.CampaignTakeawayOptionResponseDto;

/**
 * Adapts the campaign serve DTO into the frontend `ICampaign` the survey flow renders and edits.
 * The narrowings the frontend relies on (question `type` -> QuestionType, `displayColumns` -> 2|3|4)
 * are applied here, once, at this seam — the API call itself stays typed as the generated DTO.
 */
export function toCampaign(dto: CampaignRespDto): ICampaign {
  return {
    campaign: toCampaignContent(dto.campaign),
    info: toCampaignInfo(dto.info),
    demographics: dto.demographics,
  };
}

function toCampaignContent(dto: CampaignContentDto): ICampaignContent {
  return {
    ...dto,
    questions: dto.questions.map(toCampaignQuestion),
    translations: {
      title: dto.translations.title,
      subtitle: dto.translations.subtitle ?? undefined,
    },
  };
}

function toCampaignInfo(dto: CampaignInfoDto): ICampaignInfo {
  return {
    venueName: dto.venueName,
    branding: dto.branding,
    languages: dto.languages,
    advertisement: dto.advertisement ?? undefined,
    wheel: dto.wheel,
  };
}

function toCampaignQuestion(dto: CampaignQuestionDto): ICampaignQuestion {
  return {
    ...dto,
    type: dto.type as QuestionType,
    displayColumns: (dto.displayColumns ?? undefined) as 2 | 3 | 4 | undefined,
    translations: dto.translations,
    options: dto.options?.map(toCampaignOption),
  };
}

function toCampaignOption(dto: CampaignOptionDto): ICampaignOptions {
  return {
    ...dto,
    translations: dto.translations ?? { option: [] },
    value: undefined,
  };
}
